// LocalStorage example for Laravel Authentication token
const tokenStorageKey = 'sanctum.storage.token';
const localTokenStorage = {
    get: async () => {
        if (import.meta.server) {
            return undefined;
        }

        return window.localStorage.getItem(tokenStorageKey) ?? undefined;
    },

    set: async (app, token) => {
        if (import.meta.server) {
            return;
        }

        if (!token) {
            window.localStorage.removeItem(tokenStorageKey);
            return;
        }

        window.localStorage.setItem(tokenStorageKey, token);
    },
};

export default defineAppConfig({
  ui: {
    container: {
      padding: 'px-0 sm:px-0 lg:px-0',
      constrained: 'max-w-screen-2xl' // 1536px
    },
    primary: 'selective-yellow'
  },

  sanctum: {
    tokenStorage: localTokenStorage,
    interceptors: {
      onRequest: async (app, ctx, logger) => {
        ctx
          .options
          .headers
          .set('Accept-Language', app.$i18n?.locale?.value ?? 'da')
      },
    },
  },
})
